import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Lightbox.css';
import { cloudImg, makeName } from '../../general';
import { get } from '../../api/axios_call';
import BoxHeader from './BoxHeader';

const useCatalogue = (hash) => {
  const [images, setImages] = useState(null);
  useEffect(() => {
    let sourceOuter;
    get(`catalogue/${hash}`, false).then(([res, source]) => {
      sourceOuter = source;
      setImages(
        <div className="one_lightbox_wrap">
          <p className="lightbox_wrap_title_header">Lightbox</p>
          <p className="lightbox_wrap_title_p">{res.data.title}</p>
          <BoxHeader hash={hash} single />
          <div className="lightbox">
            <div className="lightbox_images">
              {res.data.images.map(({
                high,
                thumb: { crop_3: Crop3 },
                representative: {
                  slug,
                  lastName,
                  firstName,
                  type,
                  category,
                },
              }) => (
                <Link to={`/${type}/${category}/portfolio/${slug}`}>
                  <div className="lightbox_image_one">
                    <img className="lightbox_image_img" src={cloudImg(Crop3)} alt={cloudImg(Crop3)} />
                    <div className="lightbox_one_overlay"><Link to={high}>High res</Link></div>
                    <span className="lightbox_image_one_text">
                      {makeName(firstName, lastName)}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>,
      );
    });
    return () => {
      sourceOuter.cancel();
      setImages(null);
    };
  }, [hash]);
  return images;
};

export default ({ match }) => {
  const { hash } = match.params;
  const images = useCatalogue(hash);
  return images;
};
